import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { getCartCount } = useCart();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header" dir="ltr">
      <div className="header-container container">
        <Link to="/" className="logo">
          <span className="logo-kanji">東京</span>
          <span className="logo-text">WEAR</span>
        </Link>

        <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
            Home <span className="nav-kanji">ホーム</span>
          </Link>
          <Link to="/shop" className="nav-link" onClick={() => setMenuOpen(false)}>
            Shop <span className="nav-kanji">ショップ</span>
          </Link>
          <Link to="/cart" className="nav-link cart-link" onClick={() => setMenuOpen(false)}>
            Cart <span className="nav-kanji">カート</span>
            {getCartCount() > 0 && (
              <span className="cart-badge">{getCartCount()}</span>
            )}
          </Link>
        </nav>

        <div className="mobile-menu-icon" onClick={toggleMenu}>
          <span className={menuOpen ? 'active' : ''}></span>
          <span className={menuOpen ? 'active' : ''}></span>
          <span className={menuOpen ? 'active' : ''}></span>
        </div>
      </div>
    </header>
  );
};

export default Header;
